import {useState} from 'react';

import type {CompanyLink, DealLink, JobLink, PersonLink} from './structs';

export const useEmailSyncLinkState = () => {
  const [personLinks, setPersonLinks] = useState<PersonLink[]>([]);
  const [companyLinks, setCompanyLinks] = useState<CompanyLink[]>([]);
  const [jobLinks, setJobLinks] = useState<JobLink[]>([]);
  const [dealLinks, setDealLinks] = useState<DealLink[]>([]);

  return {
    personLinks,
    setPersonLinks,
    companyLinks,
    setCompanyLinks,
    jobLinks,
    setJobLinks,
    dealLinks,
    setDealLinks,
  };
};
